const ConstantFile: any = {
    contractorListPaginationObject: {
        sizePerPage: 10,
        custom: true,
    },
    contractorListTableColumns: [
        {
            text: "Contractor ID",
            dataField: "contractorId",
            headerClasses: "bs-table-header-cell",
            sort: true,
            title: true,
        },
        {
            text: "Company Name",
            dataField: "contractorName",
            sort: true,
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        {
            text: "City, State",
            dataField: "region",
            sort: true,
            headerClasses: "bs-table-header-cell city-state",
            title: true,
        },
    ],
    inActiveContractorTitle: "Inactive contractor",
    inActiveContractorDescription: "You have selected an inactive contractor, are you sure you want to continue?",
    inActiveContractorButtonText: "YES, CONTINUE",
    deleteGeneralTitle: "Are you sure you want to delete?",
    deleteGeneralDescription: "You will lose any information that you entered into this section.",
    deleteGeneralButtonText: "YES, DELETE",
    deleteFormButtonText: "YES, DELETE FORM",
    deleteDraftButtonText: "YES, DELETE DRAFT",
    // navigateAwayTitle: "Are you sure you wish to navigates away from the current application?",
    navigateAwayDescription: "You’re about to lose your work",
    navigateCheckboxText: "Do not show again",
    navigateAwayConfirmButtonText: "CONTINUE",
    contactGafTitle: "Contact GAF",
    contactGafSubTitle: "Contractor Services",
    contactGafMailaddress: "ccp@gaf.com",
    // \n\u2022 is bullet point with this string
    contactGafPhoneNo: "(877) 423-7663 \n\u2022 options 3,2",
    contactGafWorkHours: "Monday - Friday 7:30 am - 5:00 pm EST",
    draftTableDefaultSorted: [
        {
            dataField: "date",
            order: "desc",
        },
    ],
    draftTableColumns: [
        {
            text: "Building address",
            dataField: "buildingAddress",
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        {
            text: "City, State",
            dataField: "region",
            sort: true,
            headerClasses: "bs-table-header-cell city-state",
            title: true,
        },
        {
            text: "Warranty Type",
            dataField: "warrantyType",
            sort: true,
            headerClasses: "bs-table-header-cell warranty-type",
            title: true,
        },
        {
            text: "Owner",
            dataField: "owner",
            sort: true,
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        {
            text: "Date",
            dataField: "date",
            sort: true,
            headerClasses: "bs-table-header-cell",
        },
        {
            text: "",
            dataField: "delete",
            headerClasses: "bs-table-header-cell delete-col",
            title: true,
        },
    ],
    submittedGridColumns: [
        // {
        //     text: "Warranty #",
        //     dataField: "warrantyId",
        //     headerClasses: "bs-table-header-cell header-warranty-id",
        //     title: false,
        // },
        {
            text: "Warranty #",
            dataField: "warrantyNumber",
            headerClasses: "bs-table-header-cell header-warranty-id",
            title: false,
        },
        {
            text: "Cart #",
            dataField: "cartId",
            headerClasses: "bs-table-header-cell header-cart-id",
            title: false,
        },
        {
            text: "Building address",
            dataField: "buildingAddress",
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        {
            text: "City, State",
            dataField: "region",
            sort: true,
            headerClasses: "bs-table-header-cell city-state",
            title: true,
        },
        {
            text: "Warranty Type",
            dataField: "warrantyType",
            sort: true,
            headerClasses: "bs-table-header-cell warranty-type",
            title: true,
        },
        {
            text: "Owner",
            dataField: "owner",
            sort: true,
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        // {
        //     text: "Status",
        //     dataField: "status",
        //     sort: true,
        //     headerClasses: "bs-table-header-cell warranty-status-col",
        //     title: true,
        // },
        {
            text: "Fee",
            dataField: "fee",
            sort: true,
            // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
            sortFunc: (a, b, order) => {
                if (order === 'asc') {
                    return parseInt(b) - parseInt(a);
                }
                return parseInt(a) - parseInt(b); // desc
            },
            headerClasses: "bs-table-header-cell warranty-fee-col",
            title: true,
        },
        {
            text: "PostedDate",
            dataField: "postedDate",
            sort: true,
            headerClasses: "bs-table-header-cell header-posted-date",
        },
        {
            text: "",
            dataField: "delete",
            headerClasses: "bs-table-header-cell header-action-icons",
            title: true,
        },
    ],
    thankYouGridColumns: [
        // {
        //     text: "Warranty #",
        //     dataField: "id",
        //     headerClasses: "bs-table-header-cell warranty-id",
        //     title: true,
        // },
        {
            text: "Warranty #",
            dataField: "warrantyNum",
            headerClasses: "bs-table-header-cell warranty-id",
            title: true,
        },
        {
            text: "Building address",
            dataField: "buildingAddress",
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        {
            text: "City, State",
            dataField: "region",
            sort: false,
            headerClasses: "bs-table-header-cell city-state",
            title: true,
        },
        {
            text: "Warranty Type",
            dataField: "warrantyType",
            sort: false,
            headerClasses: "bs-table-header-cell warranty-type",
            title: true,
        },
        {
            text: "Owner",
            dataField: "owner",
            sort: false,
            headerClasses: "bs-table-header-cell",
            title: true,
        },
        {
            text: "PostedDate",
            dataField: "postedDate",
            sort: false,
            headerClasses: "bs-table-header-cell",
        },
        {
            text: "",
            dataField: "delete",
            headerClasses: "bs-table-header-cell header-action-icons",
            title: true,
        },
    ],
    defaultApiErrorMessage: "Something went wrong. Please try again.",
    accessDeniedErrorMessage:
        "You do not have permission to access Residential Warranty/Guarantee Registration. Please contact a member of your company",
    impersonationAccessDeniedMessage:
        "Access Denied: Impersonation Not Allowed. Access the warranty application from your CCZ account and then choose a contractor.",
    paymentError: "Your transaction has cancelled / failed. Please try again",
    adminDeleteDescriptionPopup:
        "By doing so, you will reverse the payment and the contractor will be credited the full amount of the warranty.",
    adminDeleteTitlePopup: "Are you sure you want to delete this warranty?",
    adminDeleteConfirmButtonPopup: "YES, DELETE",
    adminNoWarrantyIdErrorMessage: "Please enter a warranty ID.",
    tm: {
        searchHelpText:
            "Search for a contractor by certification number, account number, company name, or city. To show all active certified contractors assigned to you, enter an asterisk (*) in the search bar and press enter. Then click on the contractor to begin registering on their behalf.",
    },
    gafLogins: ['gaf.com', 'gaf.energy', 'gaf-mnrinterstateroofing.com'],
    hideSolarOptions: ["NonSolarContractors"],
    autoHideToasts: 10 * 1000, // Auto hide error or success msg
    stdOktaLogoutUrl: 'https://standardindustries.okta-emea.com/login/signout?fromURI=',
    errorFieldConst: {
        steepSlopeSq: "Steep Slope Squares",
        requiredSection: "Qualifying accessories",
        rakes: "Starter Strip",
    },
    validate_warrantyTypes:"President's Club"
};

export default ConstantFile;
